"use strict";

define('controller/message.template/detail',['require','exports','module','backbone','handlebars','../base','templates','libs/route.helper','appkit/changes.helper','appkit/loader.helper','langs','../../view/message.template/message.template.detail'],function (require, exports, module) {
  var Backbone = require('backbone');
  var Handlebars = require('handlebars');
  var RegionController = require('../base');
  var Templates = require('templates');
  var RouteHelper = require('libs/route.helper');
  var ChangesHelper = require('appkit/changes.helper');
  var LoaderHelper = require('appkit/loader.helper');
  var langs = require('langs');
  var MessageTemplateDetailView = require('../../view/message.template/message.template.detail');
  var MessageTemplateDetailController = RegionController.extend({
    header: langs.phrase('App.Title'),
    authorities: ['PERM_MODIFY_MESSAGE_TEMPLATE'],
    initialize: function initialize() {
      var MessageTemplate = this.model('MessageTemplate');
      this.root = new MessageTemplateDetailView();
      this.root.$el.css(this.app.config.contentCss);
      this.root.header.$el.css({
        'padding-right': '6em'
      });
      this.messageTemplate = new MessageTemplate({
        id: Number(this.state.get('messageTemplateId'))
      });
      this.changesHelper = new ChangesHelper().add(this.messageTemplate);
      this.loaderHelper = new LoaderHelper([this.messageTemplate]);
      this.messageTagsAddressable = this.model('MessageTag').allByNotificationKind(this.messageTemplate.id, true);
      this.messageTagsUnaddressable = this.model('MessageTag').allByNotificationKind(this.messageTemplate.id, false);
      this.root.messageTemplateEditor = this.request('build:messageTemplateEditor', {
        model: this.messageTemplate,
        tags: this.messageTagsUnaddressable,
        tagsAddressable: this.messageTagsAddressable
      });
      this.root.model = this.messageTemplate;
      this.root.save.model = new LoaderHelper(null, {
        delay: 0
      }).add(this.messageTemplate);
      this.configureViewEvents();
      this.configureBindings();
      this.configureModelEvents();
    },
    onStart: function onStart() {
      this.unsavedChangesModal();
      this.state.addPageDependencies([this.messageTemplate]).addPageResources([this.changesHelper, this.loaderHelper, this.messageTagsUnaddressable]);
      this.messageTemplate.fetch();
      this.messageTagsUnaddressable.fetch();
    },
    onPageLoaded: function onPageLoaded() {
      this.region.show(this.root);
    },
    onPageCancel: function onPageCancel() {
      this.root.destroy();
    },
    onPageError: function onPageError(e) {
      this.app.navigate(this.createMessageTemplateListLink().slice(1), {
        trigger: true
      });
    },
    save: function save() {
      this.messageTemplate.save();
    },
    configureBreadcrumb: function configureBreadcrumb(breadcrumb) {
      breadcrumb.collection = this.buildBreadCrumbCollection();
    },
    configureViewEvents: function configureViewEvents() {
      this.listenTo(this.root, 'save:press', function () {
        this.save();
      }).listenTo(this.root, 'preview:press', function () {
        this.popup = this.request('pdf:popup');
        this.messageTemplate.preview();
      }).listenTo(this.root, 'revert:press', function () {
        this.app.request('modal', {
          type: 'CONFIRM_DESTROY',
          action: 'Revert',
          entity: 'Message Template',
          contentText: new Handlebars.SafeString('Are you sure you want to revert back to the default' + ' message template?<br>' + '<i>All custom changes will be lost.</i>')
        }, {
          ariaControlsId: 'messageTemplateControl'
        }).on('confirm', function () {
          this.messageTemplate.destroy({
            wait: true
          });
        }, this);
      });
    },
    configureBindings: function configureBindings() {
      var revertButton = this.root.revert,
        save = this.root.save,
        header = this.root.header;
      revertButton.model = this.messageTemplate;
      revertButton.bindings.disabled = 'original';
      save.bindings.loading = 'loading';
    },
    createMessageTemplateListLink: function createMessageTemplateListLink() {
      var typeName = this.messageTemplate.get('templateType.name');
      return RouteHelper.resolve('messageTemplate:list', {
        tabName: typeName === 'Notification' ? 'notifications' : 'emails'
      });
    },
    buildBreadCrumbCollection: function buildBreadCrumbCollection() {
      return new Backbone.Collection([{
        text: langs.phrase('Settings.MessageTemplates.List.Title'),
        link: this.createMessageTemplateListLink()
      }, {
        text: langs.phrase('Settings.MessageTemplates.Details.Title')
      }]);
    },
    configureModelEvents: function configureModelEvents() {
      this.listenToOnce(this.messageTemplate, 'sync', this.onMessageTemplateOnceSync).listenTo(this.messageTemplate, 'sync', this.onMessageTemplateSync).listenTo(this.messageTemplate, 'destroy', this.onMessageTemplateDestroy).listenTo(this.messageTemplate, 'preview', this.onMessageTemplatePreview).listenTo(this.changesHelper, 'change:' + ChangesHelper.UNSAVED_CHANGES, function () {
        this.root.save.disabled = !this.changesHelper.get(ChangesHelper.UNSAVED_CHANGES);
      }).listenTo(this.loaderHelper, 'change:loading', function () {
        var form = this.root.messageTemplateEditor.form;
        form.state = this.loaderHelper.get('loading') ? 'loading' : '';
      });
    },
    unsavedChangesModal: function unsavedChangesModal() {
      this.app.request('modal', {
        type: 'UNSAVED_CHANGES',
        state: this.changesHelper
      }, {
        ariaControlsId: 'messageTemplateControl'
      }).on('save:model', this.save, this);
    },
    generateHeaderText: function generateHeaderText() {
      return this.messageTemplate.get('templateType.name') + ' - ' + this.messageTemplate.get('code.description');
    },
    onMessageTemplateOnceSync: function onMessageTemplateOnceSync() {
      var isSendable = this.messageTemplate.isSendable();
      if (isSendable) {
        this.state.addPageResources(this.messageTagsAddressable);
        this.messageTagsAddressable.fetch();
      }
    },
    onMessageTemplateSync: function onMessageTemplateSync() {
      var params = {
        messageTemplateId: this.messageTemplate.id
      };
      this.messageTagsAddressable.params(params);
      this.messageTagsUnaddressable.params(params);
      this.state.set('messageTemplateId', this.messageTemplate.id);
      this.root.header.text = this.generateHeaderText();
      this.configureBreadcrumb(this.root.breadcrumb);
    },
    onMessageTemplateDestroy: function onMessageTemplateDestroy() {
      this.messageTemplate.fetch({
        revert: true
      });
    },
    onMessageTemplatePreview: function onMessageTemplatePreview(email) {
      if (this.popup) {
        var content = '';
        if (this.messageTemplate.get('templateType.name') === 'Email') {
          content = Templates.IRB['email.message'](email.toJSON());
        } else {
          content = email.get('content');
        }
        this.request('openEmailInPopup', {
          content: content,
          popup: this.popup,
          title: 'Message Template Preview'
        });
        this.popup = null;
      }
    }
  });
  module.exports = MessageTemplateDetailController;
});

